import { SimpleModal } from '@/app/components/Modal';
import { Card, CardTitle } from '@/components/ui/card';
import { DashboardContent } from '@/layouts/dashboard';
import { useEffect, useState } from 'react';
import { FiDownload, FiEye, FiFileText } from 'react-icons/fi';

const EJASchedule = [
  {
    course: 'EJATEC Técnico em Administração',
    subtitle: 'Módulo 05',
    schedule: '/grade-horaria-canal/EJA/modulo-5.jpeg'
  },
  {
    course: 'EJATEC Técnico em Administração',
    subtitle: 'Módulo 03',
    schedule: '/grade-horaria-canal/EJA/modulo-3.jpeg'
  },
  {
    course: 'EJATEC Técnico em Administração',
    subtitle: 'Módulo 01',
    schedule: '/grade-horaria-canal/EJA/modulo-1.jpeg'
  },
  {
    course: 'EJA ETAPA V',
    subtitle: 'Qualificação Profissional',
    schedule: '/grade-horaria-canal/EJA/eja-etapa-v.jpeg'
  },
  {
    course: 'EJA ETAPA V',
    subtitle: 'Qualificação Profissional em Auxiliar Administrativo',
    schedule: '/grade-horaria-canal/EJA/eja-etapa-v-adm.jpeg'
  }
];

const EM1Schedule = [
  {
    course: '1ª Série Integral',
    subtitle: '',
    schedule: '/grade-horaria-canal/EM1/integral.jpeg'
  },
  {
    course: '1ª Série Parcial Noturna',
    subtitle: 'Integrada com o Tec. em Administração',
    schedule: '/grade-horaria-canal/EM1/parcial-noturna.jpeg'
  }
];

const EM2Schedule = [
  {
    course: '2ª Série Integral',
    subtitle: '',
    schedule: '/grade-horaria-canal/EM2/integral.jpeg'
  },
  {
    course: '2ª Série Parcial Noturna',
    subtitle: 'Integrada com o Tec. em Administração',
    schedule: '/grade-horaria-canal/EM2/parcial-noturna.jpeg'
  }
];

const EM3Schedule = [
  {
    course: '3ª Série Parcial Regular Noturna',
    subtitle: '',
    schedule: '/grade-horaria-canal/EM3/noturna.jpeg'
  },
  {
    course: '3ª Série Integral',
    subtitle: '',
    schedule: '/grade-horaria-canal/EM3/integral.jpeg'
  },
  {
    course: '3ª Série Parcial Tarde',
    subtitle: '',
    schedule: '/grade-horaria-canal/EM3/tarde.jpeg'
  },
  {
    course: '3ª Série Parcial Manhã',
    subtitle: '',
    schedule: '/grade-horaria-canal/EM3/manha.jpeg'
  }
];

export default function CourseSchedule(props) {
  const connection = localStorage.getItem('DBNumber');

  const { uri } = props;
  const [openModal, setOpenModal] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [currentSchedule, setCurrentSchedule] = useState(null);

  useEffect(() => {
    switch (connection) {
      case '4': // EJA
        setCurrentSchedule(EJASchedule);
        break;
      case '3': // EM1
        setCurrentSchedule(EM1Schedule);
        break;
      case '2': // EM2
        setCurrentSchedule(EM2Schedule);
        break;
      case '1': // EM3
        setCurrentSchedule(EM3Schedule);
        break;
      default:
        setCurrentSchedule(null);
    }
  }, [connection]);

  const breadcrumbs = {
    title: 'Cursos e Aulas',
    nav: [
      {
        route: uri,
        name: 'Horários',
        isActive: true
      }
    ]
  };

  const handleDownload = url => {
    const link = document.createElement('a');
    link.href = url;
    link.download = 'grade-horaria.jpg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <DashboardContent breadcrumbs={breadcrumbs}>
      <p>Clique nos cursos abaixo para visualizar a grade horária</p>
      <div className="grid grid-cols-3 gap-2">
        {currentSchedule?.map(item => (
          <Card
            className="min-h-20 cursor-pointer"
            hover
            onClick={() => {
              setSelectedSchedule(item);
              setOpenModal(true);
            }}
          >
            <div className="flex h-full w-full items-center gap-2 px-3">
              <div className="flex-1">
                <CardTitle>{item.course}</CardTitle>
                <p className="mb-0">{item.subtitle}</p>
              </div>

              <FiEye className="h-6 w-6" />
            </div>
          </Card>
        ))}
      </div>
      <SimpleModal
        show={openModal}
        onClose={() => setOpenModal(false)}
        contentClassName="simple-modal__content--full"
      >
        <FiDownload
          className="absolute right-12 top-3.5 h-5 w-5 cursor-pointer text-primary"
          onClick={() => handleDownload(selectedSchedule?.schedule)}
        />
        {selectedSchedule && (
          <img
            src={selectedSchedule.schedule}
            alt="Horário"
            className="mt-3 w-full"
          />
        )}
      </SimpleModal>
    </DashboardContent>
  );
}
